import { getGlobalI18nInstance } from '@mc/i18n'
import { paths } from '@mc/paths'
import Link from 'components/Link'

const i18nInstance = getGlobalI18nInstance()

const t = i18nInstance.getFixedT(null, '@mc/next')

export const GuestPassTermsLink = ({
  className = '',
  copy = t('guestPass.terms.cta.basicLabel'),
  onClick = () => {},
}: {
  className?: string
  copy?: string
  onClick?: () => void
}) => (
  <Link
    passHref
    href={paths.guestPassTermsPath}
    className={`mc-text--link ${className}`}
    target='_blank'
    rel='noopener noreferrer'
    onClick={onClick}
    newTab
    data-testid='guest-pass-terms-link'
  >
    {copy}
  </Link>
)
